import { Box, Text, VStack } from "@chakra-ui/react";

/**
 * Shown when a year exists but has no rows yet.
 *
 * Says what to do next rather than only that something is absent — an empty table with no guidance is
 * indistinguishable from a broken one.
 */
export default function EmptyState({ title, description, children }) {
  return (
    <Box
      borderWidth="1px"
      borderStyle="dashed"
      borderColor="gray.300"
      borderRadius="md"
      py={12}
      px={6}
    >
      <VStack spacing={2}>
        <Text fontWeight="600" color="darkTeal">
          {title}
        </Text>
        {description ? (
          <Text fontSize="sm" color="gray.600" textAlign="center" maxW="480px">
            {description}
          </Text>
        ) : null}
        {children}
      </VStack>
    </Box>
  );
}
